import { useEffect, useRef, useState } from "react"
import { useAppSelector } from "../../../../hooks/store-hooks"
import { useIPPermitidoService } from "../../../../../use-cases/ip-permitido"
import { useUIService } from "../../../../../use-cases/ui"
import { useNavigationService } from "../../../../../use-cases/navigation"
import { AppBar, Button, debounce, Dialog, DialogActions, DialogContent, Grid, TextField, Toolbar, Typography } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close'
import { ITipoUsuario } from "../../../../../application/models"

export const FormCreateIPPermitido = () => {
    // State
    const { insertIPPermitidoForm } = useAppSelector((state) => state.ipPermitido)
    const user = useAppSelector((state) => state.user.currentUser)
    // Use State
    const [loading, setLoading] = useState<boolean>(true)
    // Use Ref
    const isFirstRender = useRef(false)
    // Service
    const {
        setInsertIPPermitidoOpenForm,
        setInsertIPPermitidoFormIP,
        insertIPPermitido
    } = useIPPermitidoService()
    const { setAlert } = useUIService()
    const { navigateTo } = useNavigationService()

    // Lógica de permissão baseada no tipo de usuário
    const isVelesUser = user?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_DEMAIS
    const isTecnologiaDaInformacao = user?.IdVelesPerfilInterno === ITipoUsuario.TECNOLOGIA_DA_INFORMACAO
    const isSupervisorComercial = user?.IdVelesPerfilInterno === ITipoUsuario.VELES_SUPERVISOR_COMERCIAL
    const isComercial = user?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_COMERCIAL
    const isExperienciaCliente = user?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_EXPERIENCIA_DO_CLIENTE
    const isCliente = user?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_CLIENTE

    const canEdit = isVelesUser || isTecnologiaDaInformacao || isCliente
    const canView = isVelesUser || isTecnologiaDaInformacao || isSupervisorComercial || isComercial || isExperienciaCliente || isCliente

    // useEffect
    useEffect(() => {
        if (!isFirstRender.current) {
            setLoading(false)
            isFirstRender.current = true

            if (!insertIPPermitidoForm.fields.IdClienteAInserir || insertIPPermitidoForm.fields.IdClienteAInserir === 0) {
                setAlert({
                    message: 'Você deve selecionar um cliente',
                    type: 'error'
                })

                navigateTo({
                    route: '/dashboard/trava/ip-permitido'
                })
            }
        }

    }, [insertIPPermitidoForm.fields, navigateTo, setAlert, canView])

    // Function
    const handleClose = () => {
        setInsertIPPermitidoOpenForm({
            open: false
        })
    }

    if (!canView) {
        return null
    }

    return (
        loading ? <></>
            : <>
                <Dialog
                    open={true}
                    fullScreen
                    disableEscapeKeyDown
                    onClose={handleClose}
                    scroll={'paper'}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <Typography sx={{ ml: 2, flex: 1 }} textTransform={"uppercase"} fontWeight={"bold"} variant="h6" component="div">
                                {canEdit ? 'Liberar IP' : 'Visualizar Bloqueio de IP'}
                            </Typography>
                            <Button
                                color="inherit"
                                startIcon={<CloseIcon />}
                                onClick={handleClose}
                                aria-label="close"
                            >
                                Fechar
                            </Button>
                        </Toolbar>
                    </AppBar>
                    <DialogContent dividers={true}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    defaultValue={insertIPPermitidoForm.fields.IP}
                                    onChange={debounce((e) => {
                                        if (!canEdit) return;
                                        setInsertIPPermitidoFormIP({
                                            IP: e.target.value
                                        })
                                    }, 500)}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    error={Boolean(insertIPPermitidoForm.touched && insertIPPermitidoForm.errors.find(item => item.key === 'IP'))}
                                    helperText={insertIPPermitidoForm.errors.find(item => item.key === 'IP')?.message}
                                    name="ip"
                                    fullWidth
                                    id="ip"
                                    label="IP"
                                    autoFocus
                                    disabled={!canEdit}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    {canEdit && (
                        <DialogActions>
                            <Button onClick={handleClose}>Cancelar</Button>
                            <Button onClick={insertIPPermitido} variant="contained">Liberar IP</Button>
                        </DialogActions>
                    )}
                </Dialog>
            </>
    )
}